const FORM_CONTEXT_PHYSICAL_WORLD = {
  FORM_RECEIVERS: 'formReceivers',
  FORM_TERMINAL_DATA: 'formTerminalData',
  FORM_ADDRESS: 'formAddress',
  FORM_OPEN_HOURS: 'formOpenHours',
  FORM_OBSERVATION: 'formObservation',
  FORM_ROLL_QUANTITY: 'formRollQuantity'
}

export default FORM_CONTEXT_PHYSICAL_WORLD
